/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Huu Khang Nguyen
 * Created: 04/03/22
 */

import { FormControl, FormControlProps, FormLabel, FormLabelProps, Stack } from '@chakra-ui/react';
import { SystemProps } from '@chakra-ui/system';
import React from 'react';
import { LabelSide, renderFlexDirection } from '@/components/FormInputField/utils';

export interface FormControlWrapperWithLabelProps {
    label: string;
    labelSide?: LabelSide;
    labelAlign?: SystemProps['alignItems'];
    labelProps?: FormLabelProps;
    controlProps?: FormControlProps;
}

export const FormControlWrapperWithLabel = (
    props: FormControlWrapperWithLabelProps & {
        children: React.ReactNode;
    },
) => {
    const { label, labelSide = 'left', labelAlign = 'center', labelProps, controlProps, children } = props;
    return (
        <FormControl as={Stack} direction={renderFlexDirection(labelSide)} align={labelAlign} {...controlProps}>
            <FormLabel whiteSpace={'nowrap'} m={0} fontWeight={'normal'} {...labelProps}>
                {label}
            </FormLabel>
            {children}
        </FormControl>
    );
};
